import MicroModal from 'micromodal';

export const modal = (() => {
	MicroModal.init({
		disableScroll: true,
	});

	// console.log('modal!', MicroModal);
})()
